import axios from 'axios';
import { Platform } from 'react-native';
import { getWorkflowV2URI } from '../paths';

export const NewsWorkflowClient = axios.create({
  baseURL: getWorkflowV2URI(),
  timeout: 60000,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'x-device-id': 'e778ab8635e9d9c3',
    ...(Platform.OS !== 'web' && { 'Accept-Encoding': 'gzip' }),
  },
});

NewsWorkflowClient.interceptors.request.use(async (config) => {
  config.headers['x-device-id'] = 'e778ab8635e9d9c3';
  return Promise.resolve(config);
});
